import React from 'react';
import PropTypes from 'prop-types';

import { ButtonPrimary, ButtonSecondary } from '@klarna/bubble-ui';

import SelectLanguageDialog from './SelectLanguageDialog';

class LanguageSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showDialog: false };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen() {
    this.setState({ showDialog: true });
  }

  handleClose() {
    this.setState({ showDialog: false });
  }

  render() {
    const { language, saveLanguage, darkMode } = this.props;
    const ButtonComponent = darkMode ? ButtonPrimary : ButtonSecondary;
    return (
      <>
        <ButtonComponent type="button" size="small" onPress={this.handleOpen}>
          {language.toUpperCase()}
        </ButtonComponent>
        {this.state.showDialog && (
          <SelectLanguageDialog onClose={this.handleClose} saveLanguage={saveLanguage} />
        )}
      </>
    );
  }
}

LanguageSelector.propTypes = {
  language: PropTypes.string.isRequired,
  saveLanguage: PropTypes.func.isRequired,
  darkMode: PropTypes.bool,
};
export default LanguageSelector;
